/**
 * Internal logging utility for monitoring service
 * Logs are only enabled in development mode
 */

type LogLevel = "debug" | "info" | "warn" | "error";

interface LoggerConfig {
  enabled: boolean;
  prefix: string;
}

const config: LoggerConfig = {
  enabled: import.meta.env.DEV,
  prefix: "[Datadog]",
};

function log(level: LogLevel, message: string, ...args: unknown[]): void {
  if (!config.enabled && level !== "error") {
    return;
  }

  const fullMessage = `${config.prefix} ${message}`;

  switch (level) {
    case "debug":
      console.debug(fullMessage, ...args);
      break;
    case "info":
      console.info(fullMessage, ...args);
      break;
    case "warn":
      console.warn(fullMessage, ...args);
      break;
    case "error":
      console.error(fullMessage, ...args);
      break;
  }
}

export const logger = {
  debug: (message: string, ...args: unknown[]) => log("debug", message, ...args),
  info: (message: string, ...args: unknown[]) => log("info", message, ...args),
  warn: (message: string, ...args: unknown[]) => log("warn", message, ...args),
  error: (message: string, ...args: unknown[]) => log("error", message, ...args),
};
